<p-card *ngIf="loading && !job" class="loading-card">
  <div class="loading-content">
    <i class="pi pi-spin pi-spinner text-2xl text-primary mb-2"></i>
    <p>Loading job status...</p>
  </div>
</p-card>

<p-card *ngIf="error" class="error-card" severity="danger">
  <div class="error-content">
    <i class="pi pi-exclamation-triangle text-2xl text-red-500 mb-2"></i>
    <h3>Error</h3>
    <p>Failed to load job status: {{ error }}</p>
    <button pButton pRipple label="Retry" icon="pi pi-refresh" 
            class="p-button-outlined p-button-secondary mt-2"
            (click)="retry()"></button>
  </div>
</p-card>

<p-card *ngIf="job" class="job-status-card">
  <ng-template pTemplate="header">
    <div class="status-header">
      <div class="header-left">
        <i [class]="getStatusIcon(job.status)" class="text-xl mr-2"></i>
        <h3 class="m-0">Lead Distribution</h3>
      </div>
      <p-tag [severity]="getStatusSeverity(job.status)" 
             [value]="job.status.toUpperCase()"></p-tag>
    </div>
  </ng-template>

  <div class="job-content">
    <!-- Progress Section -->
    <div class="progress-section mb-4">
      <div class="progress-header mb-2">
        <span class="progress-label">Progress</span>
        <span class="progress-percentage">{{ getDisplayProgress() }}%</span>
      </div>
      <p-progressBar 
        [value]="getDisplayProgress()" 
        [showValue]="true"
        styleClass="custom-progressbar"
        class="mb-2">
      </p-progressBar>
      <!-- Debug info -->
      <div class="text-xs text-gray-500">Progress value: {{ getDisplayProgress() }} | Job: {{ job.status }}</div>
    </div>

    <!-- Status Message -->
    <div class="status-message mb-4">
      <p class="text-color-secondary">{{ job.message }}</p>
    </div>

    <!-- Results Section -->
    <div *ngIf="job.results" class="results-section">
      <h4 class="mb-3">Results</h4>
      <div class="results-grid">
        <div class="result-item">
          <span class="label">Platform:</span>
          <span class="value">{{ job.results.platform }}</span>
        </div>
        <div class="result-item">
          <span class="label">Leads Processed:</span>
          <span class="value">{{ job.results.leadsProcessed || 0 }}</span>
        </div>
        <div *ngIf="job.results.leadsSkipped > 0" class="result-item">
          <span class="label">Leads Skipped:</span>
          <span class="value text-orange-500">{{ job.results.leadsSkipped }}</span>
        </div>
        <div *ngIf="job.results?.errors?.length" class="result-item">
          <span class="label">Errors:</span>
          <span class="value text-red-500">{{ job.results?.errors?.length }}</span>
        </div>
        <div *ngIf="job.results.campaignId" class="result-item">
          <span class="label">Campaign ID:</span>
          <span class="value">{{ job.results.campaignId }}</span>
        </div>
      </div>
    </div>

    <!-- Error Section -->
    <div *ngIf="job.status === 'failed' && job.error" class="error-section mt-4">
      <h4 class="text-red-500 mb-2">Error Details</h4>
      <div class="error-box">
        <p class="error-message">{{ job.error }}</p>
      </div>
    </div>

    <!-- Error List -->
    <div *ngIf="job.results?.errors?.length" class="errors-section mt-4">
      <h4 class="text-red-500 mb-2">Processing Errors</h4>
      <div class="error-list">
        <div *ngFor="let error of job.results?.errors || []" class="error-item">
          <i class="pi pi-exclamation-triangle text-red-500 mr-2"></i>
          <span>{{ error }}</span>
        </div>
      </div>
    </div>

    <!-- Timestamps -->
    <div class="timestamps mt-4 pt-3 border-top-1 surface-border">
      <small class="text-color-secondary">
        Created: {{ job.createdAt | date:'medium' }}
        <span *ngIf="job.updatedAt"> | Updated: {{ job.updatedAt | date:'medium' }}</span>
      </small>
    </div>
  </div>
</p-card>